import "./skeleton.css";

/** 한 조각. 자리를 차지할 크기만 받는다 — 글자도 테두리도 없다. */
export function Skeleton({ width, height = 12, fill = false }: { width?: number; height?: number | string; fill?: boolean }) {
  return <span className={`ui-skeleton${fill ? " ui-skeleton--fill" : ""}`} style={{ width: fill ? undefined : width, height }} />;
}

/**
 * 올 화면의 밑그림 — 작업 현황판의 **구역**만 그린다: 위에 칩 줄, 아래 왼쪽에 이름 열,
 * 오른쪽에 판.
 *
 * 한때 막대를 하나하나 그렸다. 올 것의 모양을 그대로 보여 준다는 뜻이었는데, 그 막대들은
 * 실제로 올 막대와 자리가 다르다 — 값이 오면 전부 딴 데로 옮겨 앉아서, 미리 보여 준 것이
 * 오히려 눈을 엉뚱한 데 데려다 놓는다. 밑그림이 말해야 하는 것은 "무엇이 어디쯤 온다"지
 * "무엇이 정확히 어디 온다"가 아니다. 구역 셋이면 그 말은 다 한다.
 */
export function SkeletonFrame() {
  return <div className="ui-skeleton-frame" aria-hidden="true">
    <div className="ui-skeleton-chips">
      <Skeleton height={40} />
      <i />
      <Skeleton height={40} fill />
    </div>
    <div className="ui-skeleton-board">
      <Skeleton fill height="100%" />
      <Skeleton fill height="100%" />
    </div>
  </div>;
}
